import React, { useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { AiOutlineClose } from 'react-icons/ai'
import { FaExclamationTriangle } from 'react-icons/fa'

const initialState = {
  reason: '',
  error: null,
}

const UpdateVisibilityModal = ({
  showModal,
  onClose,
  onUpdate,
  isLoading,
  visibility,
  profile
}) => {
  const [state, setState] = useState(initialState)

  const handleUpdate = () => {
    const trimmedReason = state.reason.trim()

    if (!trimmedReason) {
      setState((prev) => ({ ...prev, error: 'Reason is required' }))
      return
    }

    onUpdate(trimmedReason)
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      onExit={() => setState(initialState)}
    >
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title className="mb-0">Prospect Visibility</Modal.Title>
          <Button
            variant="link"
            className="text-dark p-0 close-btn"
            onClick={handleClose}
          >
            <AiOutlineClose size={20} />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="prospect-search-update-visibility-profile mb-3">
          <img
            src={profile.picture_url}
            alt={profile.full_name}
            className="prospect-search-update-visibility-profile-img"
          />
          <div className="prospect-search-update-visibility-profile-name">
            {profile.full_name}
          </div>
        </div>
        <Form.Group>
          <Form.Control
            type="text"
            value={state.reason}
            onChange={(e) =>
              setState((prev) => ({ ...prev, reason: e.target.value }))
            }
            placeholder="Enter reason"
            className="bg-light border-0"
            autoFocus
          />
        </Form.Group>
        {state.error && (
          <div className="text-danger mt-2 d-flex align-items-center">
            <FaExclamationTriangle className="me-2" />
            {state.error}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {visibility === 'hidden' ? ' Hide' : ' Visible'}
        </Button>


      </Modal.Footer>
    </Modal>
  )
}

export default UpdateVisibilityModal

